import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from './shared/sharedServices/shared.service';
import { decrypt } from './utilities/utilityFunctions';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    public myRoute: Router,
    private sharedServices: SharedService
  ) {}
  canActivate(): boolean {
      if ((localStorage.getItem('esp-profile-details'))) {
        let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));
        if (d.profileId && d.getSpRole) {
          if (this.sharedServices.checkAdminRole(d.getSpRole)) {
            return true;
          }
          const adminType = this.sharedServices.checkAdminType(d.getSpRole);
          if (adminType === 'DAS' || adminType === 'DAS-COURSERA') {
            return true;
          }
        }
        return false;
      } else {
          localStorage.removeItem('esp-profile-details')
          localStorage.removeItem('login');
          localStorage.removeItem('ng2Idle.main.expiry');
          localStorage.removeItem('eduHistory');
          localStorage.removeItem('dob');
          localStorage.removeItem('loginDetails');
          localStorage.removeItem('addresses');
          localStorage.removeItem('primaryNationality');
          localStorage.removeItem('name');
          localStorage.removeItem('Avatar');
          localStorage.removeItem('isForeign');
          document.cookie = "profile=; _ga=0; path=/"
          this.myRoute.navigate(['auth/login'])
          return false;
      }
  }
}
